import { useState, useEffect, useMemo } from 'react';
import { analyzeDeal, baseSensitivityInputs, estimateNightlyRate } from '../utils/calculations/dealAnalysis';

function formatCurrency(value) {
  if (!isFinite(value)) return '0';
  return value.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

function formatPercent(value) {
  if (!isFinite(value)) return '0.0';
  return value.toFixed(1);
}

// Dollar amount with the sign ahead of the symbol: -$2,000 rather than $-2,000.
function formatMoney(value) {
  if (!isFinite(value)) return '$0';
  const rounded = Math.round(value);
  return `${rounded < 0 ? '-' : ''}$${Math.abs(rounded).toLocaleString()}`;
}

// Green for a gain, red for a loss.
function signClass(value) {
  return value < 0 ? 'text-terminal-red' : 'text-terminal-green';
}

export { formatCurrency, formatPercent, formatMoney, signClass };

export function useResultsAnalysis(formData) {
  const formKey = JSON.stringify(formData);
  const [sensitivityInputs, setSensitivityInputs] = useState(() => baseSensitivityInputs(formData));

  useEffect(() => {
    setSensitivityInputs(baseSensitivityInputs(formData));
  }, [formKey]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSensitivityChange = (name, value) => {
    setSensitivityInputs(prev => ({ ...prev, [name]: value }));
  };

  const analysis = useMemo(
    () => analyzeDeal(formData, sensitivityInputs),
    [formKey, sensitivityInputs] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return {
    ...analysis,
    sensitivityInputs,
    handleSensitivityChange,
    estimateNightlyRate: () => estimateNightlyRate(formData),
  };
}
